"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatch = void 0;
var dispatch = function dispatch(element, name) {
  // TODO check how we can trigger events of type !== Event (e.g. InputEvent)
  var event;
  if (typeof Event === "function") {
    event = new Event(name);
  } else {
    event = document.createEvent("Event");
    event.initEvent(name, true, true);
  }
  element.dispatchEvent(event);
};
// TODO redispatch event (see ProcessnavigationLink.handleClick)
exports.dispatch = dispatch;